module.exports = __webpack_public_path__ + "img/185-Gris Basalte Lisse.jpg";